<template>
  <nuttrema-layout-popover-cred>
    <nav class="nav" slot="top">
      <div class="nav-left">
        <div class="nav-item nav-item--title">
          {{ $t(_get(meta, 'title')) }}
        </div>
      </div>
      <div class="nav-right">
        <div class="nav-item">
          <el-button
             size="mini"
             type="danger"
             icon="far fa-trash"
            :disabled="_isEmpty(list)"
            :plain="true"
            @click="removeAll">
            {{ $t('label.remove_all') }}
          </el-button>
        </div>
      </div>
    </nav>
    <template slot="center-content">
      <div class="cmpt-images-manage">
        <section v-if="!_isEmpty(list)">
          <h4 class="section-title">{{ $t('label.images_list') }}</h4>
          <div class="section-items">
            <draggable class="manage-images-list" v-model="list" @end="onSortEnd">
              <div
                 v-for="(image, index) in list"
                 class="manage-images__image"
                :key="image.id">
                <div class="image__move">
                  <i class="far fa-arrows-v"></i>
                </div>

                <div class="image__picture">
                  <div class="image__picture__img" :style="{ 'background-image': getImagePath(image) }"></div>
                </div>

                <div class="image__description">
                  <div class="description--title">
                    <input-edit-in-place
                       class="ttl is-transparent"
                       name="title"
                      :params="image.id"
                      :placeholder="$t('label.click_to_add_day_title')"
                      :value="image.title"
                      @edited="onTitleOrDescriptionUpdate">
                    </input-edit-in-place>
                  </div>
                  <div class="description--note">
                    <input-edit-in-place
                       class="note is-transparent"
                       name="description"
                      :params="image.id"
                      :placeholder="$t('label.click_to_add_day_note')"
                      :value="image.description"
                      @edited="onTitleOrDescriptionUpdate">
                    </input-edit-in-place>
                  </div>
                </div>

                <div class="image__action">
                  <el-button
                     size="mini"
                     type="primary"
                    :plain="image.main !== true"
                    @click="setAsMain(image.id)">
                    {{ $t(image.main ? 'label.main' : 'label.set_as_main') }}
                  </el-button>
                  <el-button
                     size="mini"
                     type="danger"
                    :plain="true"
                    :disabled="list.length > 1 && image.main === true"
                    @click="removeFromList(image.id)">
                    {{ $t('label.remove') }}
                  </el-button>
                </div>
              </div>
            </draggable>
          </div>
          <!-- end ~ section-items -->
        </section>
        <section v-if="willBeDeletedList.length > 0">
          <h4 class="section-title">{{ $t('label.will_be_deleted') }}</h4>
          <div class="section-items">
            <div class="manage-images-list">
              <div
                 v-for="(image, index) in willBeDeletedList"
                 class="manage-images__image is-will-be-deleted"
                :key="image.id">
                <div class="image__move">
                  <i class="far fa-arrows-v"></i>
                </div>

                <div class="image__picture">
                  <div class="image__picture__img" :style="{ 'background-image': getImagePath(image) }"></div>
                </div>

                <div class="image__description">
                  <div class="description--title">
                    <input-edit-in-place
                       class="ttl is-transparent"
                       name="title"
                      :params="image.id"
                      :disabled="true"
                      :placeholder="$t('label.click_to_add_day_title')"
                      :value="image.title"
                      @edited="onTitleOrDescriptionUpdate">
                    </input-edit-in-place>
                  </div>
                  <div class="description--note">
                    <input-edit-in-place
                       class="note is-transparent"
                       name="description"
                      :params="image.id"
                      :disabled="true"
                      :placeholder="$t('label.click_to_add_day_note')"
                      :value="image.description"
                      @edited="onTitleOrDescriptionUpdate">
                    </input-edit-in-place>
                  </div>
                </div>

                <div class="image__action">
                  <el-button
                     size="mini"
                     type="danger"
                    :plain="true"
                    @click="cancelRemove(image.id)">
                    {{ $t('label.cancel') }}
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <!-- end ~ section-items -->
        </section>
      </div>
      <!-- end ~ cmpt-images-manage -->
    </template>
    <template slot="bottom">
      <nav class="nav">
        <div class="nav-left">
          <div class="nav-item">
            <el-button
              type="primary"
              size="small"
              :loading="Images.saving"
              @click="handleSaveChanges">
              {{ $t('label.save_changes') }}
            </el-button>
          </div>
        </div>
        <div class="nav-right">
          <div class="nav-item">
            <el-button size="small" type="text" @click="handleCancelChanges">{{ $t('label.cancel') }}</el-button>
          </div>
        </div>
      </nav>
    </template>
  </nuttrema-layout-popover-cred>
</template>

<script>
import Vue from 'vue';
import { get, clone, find, findIndex, each } from 'lodash';

import NuttremaLayoutPopoverCred from 'components/ui/layout/nuttrema-layout-popover-cred';
import InputEditInPlace from 'components/ui/input/nuttrema-input-edit-in-place';

import draggable from 'vuedraggable';

export default {
  name: 'cmpt-images-manage',
  props: {
    meta: {
      required: false,
      default: null,
    },
    Images: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutPopoverCred,
    InputEditInPlace,
    draggable,
  },
  data() {
    return {
      list: [],
      copy: [],
      willBeDeletedList: [],
    };
  },
  methods: {
    onSortEnd() {
      this.reIndex();
    },
    getImagePath(image) {
      const path = get(image, 'path', '');
      const filename = get(image, 'thumbnails.large.filename', '');
      return `url(${process.env.IMAGES_ROOT}${path}${filename})`;
    },
    onTitleOrDescriptionUpdate(data) {
      const name = data.name;
      const value = data.value;
      const imageID = data.params;
      const image = find(this.list, item => item.id === imageID);
      if (image) Vue.set(image, name, value);
    },
    removeFromList(imageID) {
      const imageIndex = findIndex(this.list, item => item.id === imageID);
      if (imageIndex !== -1) {
        const image = this.list[imageIndex];
        this.willBeDeletedList.push(image);
        this.list.splice(imageIndex, 1);
      }
      this.reIndex();
    },
    removeAll() {
      const clones = clone(this.list);
      each(clones, (image) => {
        this.willBeDeletedList.push(image);
      });
      this.list = [];
    },
    setAsMain(imageID) {
      each(this.list, (image) => {
        const value = image.id === imageID;
        Vue.set(image, 'main', value);
      });
    },
    cancelRemove(imageID) {
      const imageIndex = findIndex(this.willBeDeletedList, item => item.id === imageID);
      if (imageIndex !== -1) {
        const image = this.willBeDeletedList[imageIndex];
        this.list.push(image);
        this.willBeDeletedList.splice(imageIndex, 1);
      }
    },
    reIndex() {
      this.$nextTick(() => {
        each(this.list, (image, index) => {
          Vue.set(image, 'seq', index);
        });
      });
    },
    handleSaveChanges() {
      this.copy = clone(this.list);
      this.$emit('submit', { images_data: this.payload });
    },
    handleCancelChanges() {
      this.$emit('cancel');
    },
  },
  computed: {
    payload() {
      const data = [];
      each(this.list, (image) => {
        data.push({
          id: image.id,
          seq: image.seq,
          title: image.title || '',
          description: image.description || '',
          main: image.main || false,
          delete: false,
        });
      });
      each(this.willBeDeletedList, (image) => {
        data.push({
          id: image.id,
          delete: true,
        });
      });
      return data;
    },
  },
  created() {
    this.list = clone(get(this.Images, 'data', []));
    this.copy = clone(this.images);
  },
};
</script>

<style lang="scss">
  @import "~styles/theme/colors";
  .cmpt-images-manage {
    section {
      border-bottom: 1px solid #DBE2EF;
      .section-title {
        font-size: 1rem;
        font-weight: 400;
        padding: 1em 0.75em 0 0.75em;
        border-bottom: 1px solid #DBE2EF;
      }
      .section-items {
        background-color: #FFF;
        padding: 0.75em;
      }
      .section-help {
        font-size: 0.94rem;
        padding: 1em 0.75em;
      }
      &:last-child {
        margin-bottom: 1em;
      }
    }
    .manage-images-list {

      $default-bg: $element-ui-color-primary;
      $added-bg: $secondary-two-color-light;
      $removed-bg: $brand-danger;
      $hover-bg: $element-ui-color-primary;

      display: flex;
      align-self: stretch;
      flex-direction: column;

      .manage-images__image {
        display: flex;
        margin-bottom: 0.5em;
        align-self: stretch;
        align-items: center;
        justify-content: space-between;
        background-color: rgba($default-bg, 0.15);
        border-radius: 0.25em;

        .image__move {
          opacity: 0.15;
          display: flex;
          padding: 0 0.5em;
          transition: all 0.25s linear;
          -o-transition: all 0.25s linear;
          -moz-transition: all 0.25s linear;
          -webkit-transition: all 0.25s linear;
          &:hover {
            opacity: 1;
            cursor: pointer;
          }
        }
        // end ~ image__move

        .image__picture {
          display: flex;
          align-self: stretch;
          height: 5em;
          .image__picture__img {
            width: 5em;
            text-align: center;
            padding: 0.25em 0.5em;
            background-color: rgba($default-bg, 0.25);
            box-shadow: inset  0.5em 0px 0.5em -0.5em rgba(0, 0, 0, 0.25),
                        inset -0.5em 0px 0.5em -0.5em rgba(0, 0, 0, 0.25);
            background-size: 100% auto;
            background-repeat: no-repeat;
            background-position: center center;
          }
        }
        // end ~ image__picture


        .image__description {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 0.25em 0.5em;
          .description--title {}
          .description--note {}
        }
        // end ~ image__description

        .image__action {
          width: 8.5em;
          display: flex;
          align-self: center;
          padding: 0.25em 0.5em;
          flex-direction: column;
          > * {
            margin: 0;
            width: 100%;
            margin-bottom: 0.25em;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        // end ~ image__action

        &:hover {
          .image__move {
            opacity: 1;
          }
        }

        &.is-will-be-deleted {
          background-color: rgba($removed-bg, 0.15);
          .image__move {
            opacity: 0;
          }
          // .day__date .day__date__label {
          //   background-color: rgba($removed-bg, 0.25);
          // }
        }

      }
      // end ~ manage-images__image

    }
    // end ~ manage-images-list

  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/images/cmpt-images-manage.vue